<!-- <div *ngIf="!env.isOpenId;else notcondition"  style="height: 100%; width: 100%;"> -->
<div *ngIf="((needLogin() && !common.isAppelPayfipUserAnonyme && !env.isOpenId) || env.isOpenId) && !navigateurPasSupporter"
    style="height: 100%">
    <nav class="navbar navbar-inverse bg-inverse  navbar-expand-lg" *ngIf="!showClient && !env.isOpenId"
        role="navigation" [ngClass]="{'anotherColor':  colorMenu !== '#376194', 'disabledbutton': common.isLoadingApp}"
        [ngStyle]="{'background-color': colorMenu}">
        <div class="collapse navbar-collapse navbar-responsive-collapse" style="padding: 0; display: block !important;"
            [ngStyle]="{'width': showBrd ? 'calc(100% - 160px)' : '100%', 'flex-basis': showBrd ? 'calc(100% - 160px)' : '100%' }">
            <ul class="nav text-center col-sm-1" style="width: 60px;    display: inline-block;">
                <li style="width:100%">
                    <img [src]="iconTampon" alt="logo" style="height:31px; ">
                </li>
                <div class="menubas"></div>
            </ul>
            <div id="menu" class="col-sm-12"
                style=" overflow: hidden; height: 100%; width: calc(100% - 65px); display: inline-block; padding: 0;">
                <app-menu (logout)="logout()" (showBrdfct)="showBrand()" [showBrd]="showBrd"></app-menu>
            </div>
        </div>
        <div class="navbar-header">
            <div *ngIf="showBrand()" class="toggleBtn" data-toggle="collapse"
                style="transform: rotate(-90deg);width: 30px;height: 30px;">
                <i class=" col-sm-12 fa fa-angle-up" style="padding: 0px;" aria-hidden="true"
                    (click)="scrollMenuTop()"></i>
                <i class=" col-sm-12 fa fa-angle-down" style="padding: 0px;" aria-hidden="true"
                    (click)="scrollMenuBottom()"></i>
            </div>
            <div *ngIf="showBrand()" class="menubas" style="width: 30px;position: absolute;top: 33px;"></div>
        </div>
        <div *ngIf="showBrand()" style="width: 80px;">
            <ul class="nav navbar-nav text-center col-sm-12" style="padding: 0px;">
                <li class="nav-item btnQuitter" (mouseover)="common.clickMenu.compte = true;"
                    (mouseleave)="common.clickMenu.compte = false;" [routerLinkActive]="['active']">
                    <a class="text-maj text-center" style="padding-bottom: 0px !important; height: 30px;">
                        <div style=" height: 15px; width: 15px;">
                            <i class="fa fa-user-circle" aria-hidden="true" style="font-size: 1.5em !important;"></i>
                        </div>
                        <span> {{user ? (user.login || '') : 'Votre Compte'}} </span>
                    </a>
                    <ul class="nav sousmenu rightMenu0" [ngClass]="{'activeSous': menuSelected() === 'compte'}"
                        *ngIf="common.clickMenu.compte">
                        <li class="nav-item">
                            <a href="javascript:void(0)" class="text-maj text-center"
                                (click)="common.openModalInfo(modalService);common.clickMenu.compte = false;">
                                <div>
                                    <i class="fa fa-question-circle-o" aria-hidden="true"
                                        style="font-size: 1.3em !important;padding-top: 4px;"></i>
                                </div>
                                <span> A propos </span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a href="javascript:void(0)" class="text-maj text-center"
                                (click)="logout(); common.clickMenu.compte = false;">
                                <div>
                                    <i class="fa fa-sign-out" aria-hidden="true"
                                        style="font-size: 1.3em !important;padding-top: 4px;"></i>
                                </div>
                                <span> Quitter </span>
                            </a>
                        </li>
                    </ul>
                </li>
                <div class="menubas" style=" width: 85px;"></div>
            </ul>
        </div>
        <div class="col-sm-12 text-center menubasDiv" [ngClass]="{'menuBasEcobennes': isEcobennes}"
            style="position: absolute; top: 33px;"></div>
    </nav>
    <nav class="navbar navbar-inverse bg-inverse  navbar-expand-lg" role="navigation" *ngIf="env.isOpenId"
        [ngClass]="{'anotherColor':  colorMenu !== '#376194', 'disabledbutton': common.isLoadingApp}"
        [ngStyle]="{'background-color': colorMenu}">
        <div class="collapse navbar-collapse navbar-responsive-collapse" style="padding: 0; display: block;"
            [ngStyle]="{'width': showBrd ? 'calc(100% - 160px)' : '100%', 'flex-basis': showBrd ? 'calc(100% - 160px)' : '100%' }">
            <ul class="nav text-center col-sm-1" style="width: 60px;    display: inline-block;">
                <li style="width:100%">
                    <img [src]="iconTampon" alt="logo" style="height:31px; ">
                </li>
                <div class="menubas"></div>
            </ul>
        </div>

        <div class="col-sm-12 text-center menubasDiv" [ngClass]="{'menuBasEcobennes': isEcobennes}"
            style="position: absolute; top: 33px;"></div>
    </nav>
    <div class="corp"
        [ngClass]="{'corpclt ecoportail': showClient, 'corpecorec': !showClient, 'corpsEcobennes': isEcobennes}">
        <div class="sk-fading-circle" *ngIf="common.isloadEcoportail">
            <div class="sk-circle1 sk-circle"></div>
            <div class="sk-circle2 sk-circle"></div>
            <div class="sk-circle3 sk-circle"></div>
            <div class="sk-circle4 sk-circle"></div>
            <div class="sk-circle5 sk-circle"></div>
            <div class="sk-circle6 sk-circle"></div>
            <div class="sk-circle7 sk-circle"></div>
            <div class="sk-circle8 sk-circle"></div>
            <div class="sk-circle9 sk-circle"></div>
            <div class="sk-circle10 sk-circle"></div>
            <div class="sk-circle11 sk-circle"></div>
            <div class="sk-circle12 sk-circle"></div>
        </div>
        <router-outlet></router-outlet>
    </div>
</div>

<div class="login"
    *ngIf="(!needLogin() && !showClient && !common.isAppelPayfipUserAnonyme && !env.isOpenId) || navigateurPasSupporter"
    style="height:100%">
    <div class="col-sm-6 left" [ngStyle]="{'background-color': colorMenu}">
        <img [src]="logoLoginLeft" alt="logo">
    </div>
    <div class="col-sm-6 right">
        <alert-message></alert-message>
        <div class="form col-sm-offset-2 col-sm-8" *ngIf="!isRegister  && !navigateurPasSupporter && !bloquerClient">
            <img [src]="logoLoginRight" alt="logo ecorec" style="width: 208px;">
            <h1>Heureux de vous retrouver</h1>
            <form #form="ngForm">
                <div class="" style="margin: 20px 0px;    height: 220px;"
                    [ngStyle]="{'height': isHolding ? '290px' : '220px'}"
                    [ngClass]="{'disabledbutton': common.isLoadingApp }">
                    <div class="form-group">
                        <label *ngIf="isFocuslogin || infoUser.login"> Identifiant </label>
                        <input type="text" class="form-control" id="login-input" name="login" placeholder="Identifiant"
                            [(ngModel)]="infoUser.login" (keyup.enter)="focusNext(); initialiseObjwofact(); login(false, false);"
                            (focus)="isFocuslogin=true" (blur)="getSocieteFille();getListeSite(); isFocuslogin=false"
                            [ngStyle]="{'padding': ( isFocuslogin || infoUser.login ) ? '16px 10px 0 10px' : '6px 12px'}"
                            autocomplete="off" [disabled]="isModalMail"/>
                    </div>
                    <div class="form-group" style="margin-bottom: -12px;">
                        <label *ngIf="isFocuspass || infoUser.password"> Mot de passe </label>
                        <input id="pswd" type="password" class="form-control" name="pass" placeholder="Mot de passe"
                            [(ngModel)]="infoUser.password" (focus)="isFocuspass=true" (blur)="isFocuspass=false;"
                            (keyup.enter)="initialiseObjwofact(); login(false, true)"
                            [ngStyle]="{'padding': (isFocuspass || infoUser.password) ? '16px 10px 0 10px' : '6px 12px'}"
                            #input  [disabled]="isModalMail"/>
                        <span class="view-pass" (click)="showPassword(input)">
                            <i class="fa {{ showPass ? 'fa-eye-slash' :'fa-eye' }}" aria-hidden="true"></i>
                        </span>
                    </div>
                    <div class="form-group" *ngIf="isHolding">
                        <label> Societe </label>
                        <i class="fa fa-angle-down select-icon"></i>
                        <select class="form-control select" name="société" placeholder="Societe"
                            [(ngModel)]="infoUser.societe" (ngModelChange)="getListeSite(true)"
                            style="    height: 60px;">
                            <option *ngFor="let item of listeSociete" [ngValue]="item"> {{ item.nom }} </option>
                        </select>
                    </div>
                    <div class="form-group" *ngIf="listeSite && listeSite.length > 1">
                        <label [ngClass]="{'site': !infoUser.site}"> Site </label>
                        <i class="fa fa-angle-down select-icon"></i>
                        <select class="form-control select" name="site" [(ngModel)]="infoUser.site"
                            style="    height: 60px;">
                            <option *ngFor="let item of listeSite" [ngValue]="item.id"> {{ item.nom }} </option>
                        </select>
                    </div>
                </div>
                <button type="button" (click)="initialiseObjwofact(); login(false, true)" class="btn-login col-sm-12"
                    [ngClass]="{'disabledbutton': common.isLoadingApp }"
                    [ngStyle]="{'background-color': colorMenu !== '#376194' ? colorMenu : '#5393e0'}">
                    VALIDER
                </button>
            </form>
        </div>

        <div class="form col-sm-offset-2 col-sm-8" *ngIf="bloquerClient">

            <div class="col-sm-12 p-0">
                <div class="col-sm-12 pb-2 text-center" style="font-size: 20px;line-height: 1.7;">
                    Votre accès à Ecorec a été désactivé. <br />
                    Veuillez contacter Kerlog pour le réactiver.
                </div>
            </div>
        </div>
        <div class="copyright">&copy; {{date | date:'MMM yyyy'}} - COPYRIGHT <strong
                style="font-family: Roboto-Black;">KERLOG</strong></div>
        <div class="form col-sm-offset-2 col-sm-8" *ngIf="navigateurPasSupporter && !bloquerClient">

            <div class="col-sm-12 p-0">
                <div class="col-sm-12 pb-2">
                    Votre navigateur n'est pas compatible avec la suite EcoREC. Nous vous invitons à utiliser un nouveau
                    navigateur.
                </div>
                <div class="col-sm-12 pb-2">Si vous rencontrez des difficultés, votre version
                    nécessite peut-être une mise à jour.
                    Veuillez vérifier que vous remplissez les conditions suivantes : </div>

                <div class="col-sm-12 pl-5 pb-1">Chrome : version minimum 92.0.4515.159</div>
                <div class="col-sm-12 pl-5 pb-1">Firefox : version minimum 90.0</div>
                <div class="col-sm-12 pl-5 pb-1">Safari : version minimum 15.0</div>

                <div class="col-sm-12 pt-3">Merci pour votre compréhension.</div>
            </div>
        </div>
        <div class="copyright">&copy; {{date | date:'MMM yyyy'}} - COPYRIGHT <strong
                style="font-family: Roboto-Black;">KERLOG</strong></div>
    </div>
</div>
<!-- </div> -->



<div *ngIf="!needLogin() && showClient && !common.isAppelPayfipUserAnonyme && !env.isOpenId" class="ecoportail"
    style="height: 100%;">
    <div class="sk-fading-circle" *ngIf="common.isloadEcoportail">
        <div class="sk-circle1 sk-circle"></div>
        <div class="sk-circle2 sk-circle"></div>
        <div class="sk-circle3 sk-circle"></div>
        <div class="sk-circle4 sk-circle"></div>
        <div class="sk-circle5 sk-circle"></div>
        <div class="sk-circle6 sk-circle"></div>
        <div class="sk-circle7 sk-circle"></div>
        <div class="sk-circle8 sk-circle"></div>
        <div class="sk-circle9 sk-circle"></div>
        <div class="sk-circle10 sk-circle"></div>
        <div class="sk-circle11 sk-circle"></div>
        <div class="sk-circle12 sk-circle"></div>
    </div>
    <router-outlet></router-outlet>
</div>

<ng-template #rappel>
    <div class="modal-header">
        <h4 class="modal-title pull-left uppercase">Rappels </h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="closeRappel()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" style="height: auto">
        <div>
            <ngx-datatable #myTable class="material" style="height:250px" [rows]="listerappel" [columnMode]="'force'"
                [headerHeight]="50" [footerHeight]="0" [rowHeight]="'auto'" [selectionType]="'checkbox'"
                [messages]="{emptyMessage: 'Pas de bon à afficher'}" [loadingIndicator]="loadingIndicator">

                <ngx-datatable-column name="Date" prop="date">
                    <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                        let-selectFn="selectFn" let-sort="sortFn">
                        <div class="tableheader" (click)="sort()">
                            <span class="uppercase">Date</span>
                            <div class=" col-sm-1 pull-right">
                                <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true" (click)="sort()"></i>
                                <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true" (click)="sort()"></i>
                            </div>
                        </div>
                    </ng-template>
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                        <div class="strong"> {{value ? value.slice(0, -3) : ''}} </div>
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Sujet" prop="sujet">
                    <ng-template let-col="column" ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                        let-selectFn="selectFn" let-sort="sortFn">
                        <div class="tableheader" (click)="sort()">
                            <span class="uppercase"> Événements </span>
                            <div class=" col-sm-1 pull-right">
                                <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                                <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                            </div>
                        </div>
                    </ng-template>
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                        <div class="strong"> {{value}} </div>
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column [sortable]="false" [canAutoResize]="false" [draggable]="false"
                    [resizeable]="false" [width]="50">
                    <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                        let-selectFn="selectFn">
                        <input type="checkbox" id="checkbox-1-1 " class="regular-checkbox regular-checkbox-checked"
                            [(ngModel)]="checkedall" (ngModelChange)="checkedAll($event)"
                            [ngClass]="{'regular-checkbox-checked': checkedall}" />
                    </ng-template>
                    <ng-template ngx-datatable-cell-template let-row="row">
                        <input type="checkbox" id="checkbox-1-1" class="regular-checkbox" (change)="checkedRow(row)"
                            [(ngModel)]="row.isChecked" [ngClass]="{'regular-checkbox-checked': row.isChecked}" />
                    </ng-template>
                </ngx-datatable-column>
            </ngx-datatable>
        </div>
        <div class="text-right" style="margin-top: 15px;">
            <button type="button" class=" btn-close btn-valider" (click)="hideRappel()"> Faire disparaître la sélection
            </button>
            <button type="button" class=" btn-close" (click)="closeRappel()"> Fermer </button>
        </div>
    </div>
</ng-template>

<div class="slidemenu navbar-inverse" *ngIf="common.slideMenu  && !showClient && !common.isAppelPayfipUserAnonyme"
    [ngClass]="{'anotherColor':  colorMenu !== '#376194'}">
    <div class="menu" [ngStyle]="{'background-color': colorMenu}">
        <app-menu (logout)="logout()" [showBrd]="showBrd"></app-menu>
    </div>
</div>


<ng-template #popTemplate>
    <div class="modal-header" *ngIf="!common.msgError">
        <h4 class="modal-title pull-left"> Logs </h4>
        <button type="button" class="close pull-right" aria-label="Close"
            (click)="common.closeModal(); common.msgError = false;">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" *ngIf="!common.msgError" style="height: auto">
        <div>
            <app-log-prestation [logModifEtendu]="common.logModifEtendu" [rows]="common.listLog"
                [message]="'Pas de log à afficher'"></app-log-prestation>
        </div>
    </div>
    <div class="modal-body" style="height: auto" *ngIf="common.msgError">
        <div class="col-sm-12" style="padding: 0;">
            <div class="col-sm-12" style="padding: 0;">
                <span class="cofirmemsg"> {{ common.error }} </span>
            </div>
        </div>
        <div class="text-right col-sm-12" style="margin-top: 15px;padding: 0;">
            <button type="button" class=" btn-close btn-validerMdl"
                (click)="common.error = ''; common.closeModal();  common.msgError = false;"> Fermer
            </button>
        </div>
    </div>
</ng-template>

<ng-template #popTemplateChorus>
    <div class="modal-header" *ngIf="!common.msgError">
        <h4 class="modal-title pull-left"> Liste des logs chorus de la pièce {{ common.numFactureChorus }} </h4>
        <button type="button" class="close pull-right" aria-label="Close"
            (click)="common.closeModal(); common.msgError = false;">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" *ngIf="!common.msgError" style="height: auto">
        <div>
            <app-log-prestation [logChorus]="common.logChorus" [message]="'Pas de log à afficher'"></app-log-prestation>
        </div>
    </div>
    <div class="modal-body" style="height: auto" *ngIf="common.msgError">
        <div class="col-sm-12" style="padding: 0;">
            <div class="col-sm-12" style="padding: 0;">
                <span class="cofirmemsg"> {{ common.error }} </span>
            </div>
        </div>
        <div class="text-right col-sm-12" style="margin-top: 15px;padding: 0;">
            <button type="button" class=" btn-close btn-validerMdl"
                (click)="common.error = ''; common.closeModal();  common.msgError = false;"> Fermer
            </button>
        </div>
    </div>
</ng-template>

<ng-template #msg>
    <div class="modal-body" style="height: auto">
        <div class="col-sm-12" style="padding: 0;">
            <div class="col-sm-12" style="padding: 0;">
                <span class="cofirmemsg"> {{ error }} </span>
            </div>
        </div>
        <div class="text-right col-sm-12" style="margin-top: 15px;padding: 0;">
            <button type="button" class=" btn-close btn-validerMdl" (click)="error = ''; common.closeModal()"> Fermer
            </button>
        </div>
    </div>
</ng-template>

<ng-template #msgerror>
    <div class="modal-body" style="height: auto">
        <div class="col-sm-12" style="padding: 0;max-height: 300px; overflow-y: auto;">
            <div class="col-sm-12" style="padding: 0;">
                <span class="cofirmemsg"> {{ objetError[index] }} </span>
            </div>
        </div>
        <div class="text-right col-sm-12" style="margin-top: 15px;padding: 0;">
            <button type="button" class=" btn-close btn-validerMdl" (click)="common.closeModal()"> Fermer
            </button>
        </div>
    </div>
</ng-template>

<ng-template #msgConsole>
    <div class="modal-body" style="height: auto">
        <div class="col-sm-12" style="padding: 0;">
            <div class="col-sm-12" style="padding: 0;">
                <span class="cofirmemsg" *ngIf="!pasConnexion"> Un problème s'est produit veuillez contacter votre
                    administrateur.
                </span>
                <span class="cofirmemsg" *ngIf="pasConnexion"> Aucun accès à Internet </span>
            </div>
        </div>
        <div class="text-right col-sm-12" style="margin-top: 15px;padding: 0;">
            <button type="button" class=" btn-close btn-validerMdl" (click)="fctClose();common.closeModal(); "> Fermer
            </button>
        </div>
    </div>
</ng-template>

<ng-template #msgPasAcces>
    <div class="modal-body" style="height: auto">
        <div class="col-sm-12" style="padding: 0;">
            <div class="col-sm-12" style="padding: 0;">
                <span class="cofirmemsg"> {{ error }} </span>
            </div>
        </div>
        <div class="text-right col-sm-12" style="margin-top: 15px;padding: 0;">
            <button type="button" class=" btn-close btn-validerMdl" (click)=" common.closeModal()"> Fermer
            </button>
        </div>
    </div>
</ng-template>

<ng-template #panneauMailConfirmation>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Identification à double facteur </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal(); isModalMail = false;">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body customCss-modal" style="height: 150px;">
    <div class="col-sm-12" style="margin-bottom: 15px;height: 45px;">
      <label class="col-sm-12 textModal"> Veuillez saisir votre adresse mail pour recevoir votre code d'authentification ou pour la validation via EcoDA</label>
    </div>
    <div class="col-sm-12" style="margin-bottom: 5px;">
      <input type="text" class="form-control" id="panneaumail" placeholder="Adresse mail" [(ngModel)]="objTwoFactorAuth.mail"
      (ngModelChange)="checkValidmail()" (keydown.enter)="submitMailOnEnter()">
    </div>
  </div>
  <div class="col-sm-12 text-right valider" style="padding-bottom: 25px;">
    <button type="button" class="btn btn-valider" [disabled] = "!changerCouleurMail"  [ngClass]="{'btn-disabled': !changerCouleurMail}"  (click)="common.closeModal();verificationMail()">
      Valider
    </button>
  </div>
</ng-template>

<ng-template #panneauSaisieCode>
  <div class="modal-header">
    <h4 class="modal-title">Identification à double facteur</h4>
    <button type="button" class="close" aria-label="Close" (click)="common.closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="panneauSaisieCode">
      <p class="textModal" *ngIf="objTwoFactorAuth.step === 'ETAPE_1'">Veuillez saisir le code d'identification que vous avez reçu par mail</p>
      <div *ngIf="objTwoFactorAuth.step === 'ETAPE_2'" class="text-center mt-3">
        <p class="text-danger mb-2 errorMail expireCode">{{objTwoFactorAuth['error'] || ''}}</p>
        <p class="textModal">Veuillez saisir à nouveau le code d'identification que vous avez reçu par mail</p>
      </div>
      
      <div class="d-flex justify-content-center" *ngIf="objTwoFactorAuth">
        <input type="text" class="form-control text-center" id="code0" maxlength="1" [(ngModel)]="objTwoFactorAuth.code[0]"
          (input)="focusToNext($event, 0)" (paste)="handlePaste($event, 0)" (keydown.enter)="validateCodeOnenter()">
        <input type="text" class="form-control text-center" id="code1" maxlength="1" [(ngModel)]="objTwoFactorAuth.code[1]"
          (input)="focusToNext($event, 1)" (paste)="handlePaste($event, 1)" (keydown.enter)="validateCodeOnenter()">
        <input type="text" class="form-control text-center" id="code2" maxlength="1" [(ngModel)]="objTwoFactorAuth.code[2]"
          (input)="focusToNext($event, 2)" (paste)="handlePaste($event, 2)" (keydown.enter)="validateCodeOnenter()">
        <input type="text" class="form-control text-center" id="code3" maxlength="1" [(ngModel)]="objTwoFactorAuth.code[3]"
          (input)="focusToNext($event, 3)" (paste)="handlePaste($event, 3)" (keydown.enter)="validateCodeOnenter()">
        <input type="text" class="form-control text-center" id="code4" maxlength="1" [(ngModel)]="objTwoFactorAuth.code[4]"
          (input)="focusToNext($event, 4)" (paste)="handlePaste($event, 4)" (keydown.enter)="validateCodeOnenter()">
        <input type="text" class="form-control text-center" id="code5" maxlength="1" [(ngModel)]="objTwoFactorAuth.code[5]"
          (input)="focusToNext($event, 5)" (paste)="handlePaste($event, 5)" (keydown.enter)="validateCodeOnenter()">
      </div>
      
      <p class="mt-3" *ngIf="minutes > 0 || seconds > 0"> <span class="expireCode">Votre code expire dans :</span> {{ minutes }} min et {{ seconds }} s.</p>
      <p class="mt-3" *ngIf="minutes == 0 && seconds == 0"> <span class="expireCode">Votre code a déjà expiré.</span></p>
    </div>
    <div class="text-right valider">
      <button type="button" class="btn btn-valider" [disabled]="!isCodevalidationRempli" [ngClass]="{'btn-disabled': !isCodevalidationRempli}" (click)="validateCode()">Valider</button>
    </div>
  </div>
</ng-template>

<ng-template #panneauAttenteValidationApp>
    <div class="modal-header">
      <h4 class="modal-title">Identification à double facteur</h4>
      <button type="button" class="close" aria-label="Close" (click)="common.closeModal();">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div *ngIf="objTwoFactorAuth.error" class="text-center mt-3">
        <p class="text-danger mb-2 errorMail expireCode">{{objTwoFactorAuth['error'] || ''}}</p>
      </div>
    <div class="modal-body" *ngIf="!objTwoFactorAuth.error">
      <div class="panneauSaisieCode">
        <p class="textModal">Veuillez valider l'authentification sur l'application EcoDA sur votre téléphone.</p>
        <div class="" >
            <p class="mt-3" *ngIf="minutes > 0 || seconds > 0"> <span class="expireCode">Cette demande expire dans :</span> {{ minutes }} min et {{ seconds }} s.</p>
            <p class="mt-3" *ngIf="minutes == 0 && seconds == 0"> <span class="expireCode">Cette demande a déjà expiré.</span></p>
        </div>
        <div class="" >
            <p class="mt-3"> 
                <a href="javascript:void(0)" class="text-center" (click)="sendMailOnErrorEcoDA()">
                    Envoyer un code de connexion par mail
                </a>
            </p>
        </div>
      </div>
    </div>
  </ng-template> 
  

<ng-template #tplApropos>
    <app-apropos-ecorec></app-apropos-ecorec>
</ng-template>

<div *ngIf="common.isAppelPayfipUserAnonyme" style="height: 100%">
    <router-outlet></router-outlet>
</div>


<div class="" [ngClass]="{'spinnerNotShow': common.spinnerNotShow, 'spinner': !common.spinnerNotShow}"
    *ngIf="common.showSpinner()">
    <div class="sk-fading-circle" *ngIf="!common.spinnerNotShow">
        <div class="sk-circle1 sk-circle"></div>
        <div class="sk-circle2 sk-circle"></div>
        <div class="sk-circle3 sk-circle"></div>
        <div class="sk-circle4 sk-circle"></div>
        <div class="sk-circle5 sk-circle"></div>
        <div class="sk-circle6 sk-circle"></div>
        <div class="sk-circle7 sk-circle"></div>
        <div class="sk-circle8 sk-circle"></div>
        <div class="sk-circle9 sk-circle"></div>
        <div class="sk-circle10 sk-circle"></div>
        <div class="sk-circle11 sk-circle"></div>
        <div class="sk-circle12 sk-circle"></div>
    </div>
</div>